import Header from 'components/Recurring/Header/styled';

export default Header;
